module.exports = __webpack_public_path__ + "img/Monte_Kope_86.c66d3c76.jpg";